import FirmPromoCardPro from './FirmPromoCardPro';
import { useState, useEffect } from 'react';

function FirmPromoCarouselPro({ firms }) {
  const [current, setCurrent] = useState(0);
  const autoSlideInterval = 5000; // 5s

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % firms.length);
    }, autoSlideInterval);
    return () => clearInterval(interval);
  }, [firms.length]);

  return (
    <div className="py-16 bg-gray-950 text-yellow-100">
      <div className="container mx-auto px-4 text-center mb-10">
        <h2 className="text-3xl font-bold text-yellow-400 mb-2">Featured Prop Firm Deals</h2>
        <p className="text-yellow-300 text-sm">Best promos & exclusive codes you shouldn't miss.</p>
      </div>

      <div className="relative max-w-4xl mx-auto overflow-hidden">
        <div className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${current * 100}%)` }}>
          {firms.map((firm) => (
            <div key={firm.id} className="min-w-full px-4">
              <FirmPromoCardPro firm={firm} />
            </div>
          ))}
        </div>

        <div className="absolute inset-0 flex justify-between items-center px-4">
          <button
            onClick={() => setCurrent((current - 1 + firms.length) % firms.length)}
            className="bg-yellow-400 text-black p-2 rounded-full hover:bg-yellow-300 transition"
          >
            ◀
          </button>
          <button
            onClick={() => setCurrent((current + 1) % firms.length)}
            className="bg-yellow-400 text-black p-2 rounded-full hover:bg-yellow-300 transition"
          >
            ▶
          </button>
        </div>
      </div>
    </div>
  );
}

export default FirmPromoCarouselPro;
